import { createContext } from "react";
import { FirebaseApp } from "firebase/app";
import { Messaging } from "firebase/messaging";
import { Subject } from "rxjs";
import { FirebaseNotification, SupportedFirebaseEvent } from "./types";

export const FCMContext = createContext<{
  app: FirebaseApp | undefined;
  messaging: Messaging | undefined;
  notifications$: Subject<FirebaseNotification>;
  broadcastChannel: BroadcastChannel;
  token: string | undefined;
  logEvent: (supportedEvent: SupportedFirebaseEvent) => void;
} | null>(null);
